/* LunaError from https://wiki.unitedtraders.team/pages/viewpage.action?pageId=41320585 */

interface LunaFieldError {
  path: string;
  message: string;
  details: Record<string, string>;
}

export interface LunaError {
  type: string;
  details: {
    attributes?: Record<string, string>;
    fields?: LunaFieldError[];
    message?: string; // not described in wiki, but appears
  };
}

export interface ErrorMessage {
  message: string;
  details: Record<string, string>;
}

export type FormErrors = Record<string, ErrorMessage>;

const nonPermanentMessages = [
  'com.unitedtraders.luna.utexbridge.exception.InsufficientFundsException',
];

/**
 * Converts error from backend to form errors
 * @param error Error or LunaError
 * @param formErrorKey key for error that applies to the whole form (not a specific field)
 * @param fieldMapper mapper from `path` in backend response to `field` in form
 */
export const restErrorsToForm = (
  error: Error | LunaError,
  formErrorKey = 'FINAL_FORM/form-error',
  fieldMapper: (path: string) => string = (path) => path.split('.').pop()!
): FormErrors => {
  // not LunaError
  if (!('details' in error)) {
    return { [formErrorKey]: { message: error.message, details: {} } };
  }

  if (error.details?.fields) {
    return error.details.fields.reduce<FormErrors>(
      (result, { path, ...rest }) => ({
        ...result,
        [fieldMapper(path)]: rest,
      }),
      {}
    );
  }

  if (error.details.message && !nonPermanentMessages.includes(error.type)) {
    return {
      [formErrorKey]: {
        message: error.details.message,
        details: error.details.attributes || {},
      },
    };
  }

  return {
    [formErrorKey]: {
      message: error.type.replace(/\./g, '-'),
      details: error.details?.attributes || {},
    },
  };
};
